var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "my-select",
      on: {
        mouseenter: _vm.mouseenter,
        mouseleave: function ($event) {
          _vm.showClose = false
        },
      },
    },
    [
      _c(
        "el-dropdown",
        {
          staticStyle: { width: "100%" },
          attrs: { trigger: "click" },
          on: { "visible-change": _vm.visibleChange, command: _vm.chooseItem },
        },
        [
          _c(
            "div",
            { staticClass: "select-input" },
            [
              !_vm.presentItem && !_vm.filterable
                ? _c("div", { staticClass: "default" }, [
                    _vm._v(_vm._s(_vm.placeholder)),
                  ])
                : _vm._e(),
              !_vm.presentItem && _vm.filterable
                ? _c("el-input", {
                    attrs: { placeholder: _vm.placeholder },
                    model: {
                      value: _vm.search,
                      callback: function ($$v) {
                        _vm.search = $$v
                      },
                      expression: "search",
                    },
                  })
                : _vm._e(),
              _vm.presentItem
                ? [
                    _c("div", { staticClass: "present-top" }, [
                      _c("p", [
                        _c("span", { staticStyle: { color: "#5753E8" } }, [
                          _vm._v(_vm._s(_vm.presentItem.code)),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#333333",
                              "margin-left": "12px",
                            },
                          },
                          [_vm._v(_vm._s(_vm.presentItem.cnName) + " |")]
                        ),
                        _c("span", { staticStyle: { color: "#999999" } }, [
                          _vm._v(_vm._s(_vm.presentItem.enName)),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "present-bottom" }, [
                      _c("p", [
                        _vm._v(
                          " 税号前2位：" + _vm._s(_vm.presentItem.hsCode) + " "
                        ),
                      ]),
                    ]),
                  ]
                : _vm._e(),
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.showClose,
                    expression: "!showClose",
                  },
                ],
                class: [
                  "el-icon-arrow-up",
                  "el-icon--right",
                  _vm.arrow ? "arrowdown" : "",
                ],
              }),
            ],
            2
          ),
          _c(
            "el-dropdown-menu",
            {
              ref: "dropdownMenu",
              style: { width: _vm.width, maxHeight: "200px", overflow: "auto" },
              attrs: { slot: "dropdown" },
              slot: "dropdown",
            },
            [
              _vm.dropdownItems.length
                ? _vm._l(_vm.dropdownItems, function (item) {
                    return _c(
                      "el-dropdown-item",
                      {
                        key: item.id,
                        staticClass: "dropdownItems",
                        attrs: { command: item.code },
                      },
                      [
                        _c("div", { staticClass: "items" }, [
                          _c("p", [
                            _c("span", { staticStyle: { color: "#5753E8" } }, [
                              _vm._v(_vm._s(item.code)),
                            ]),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#333333",
                                  "margin-left": "12px",
                                },
                              },
                              [_vm._v(_vm._s(item.cnName) + " |")]
                            ),
                            _c("span", { staticStyle: { color: "#999999" } }, [
                              _vm._v(_vm._s(item.enName)),
                            ]),
                          ]),
                          _c("p", [
                            _vm._v(" 税号前2位：" + _vm._s(item.hsCode) + " "),
                          ]),
                        ]),
                      ]
                    )
                  })
                : [_c("p", { staticClass: "empty" }, [_vm._v("无数据")])],
            ],
            2
          ),
        ],
        1
      ),
      _c("i", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showClose,
            expression: "showClose",
          },
        ],
        class: ["el-icon-circle-close"],
        on: { click: _vm.close },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }